import React from "react";
import { Assets, Colors, FontFamily, Input, PrimaryButton } from "utils/imports.utils";
import { ButtonSize, ButtonTypes } from "utils/interface.utils";
import { STRINGS } from "constants/strings.constant";
import { ShareLinkFieldProps } from "interfaces/payment_modal.interface";
import "./share_link_field.component.scss";

// A read-only link with a Copy button beside it.
const ShareLinkField = (props: ShareLinkFieldProps): React.ReactElement => (
    <div className="share_link_field">
        <div className="share_link_field_input">
            <Input type="text" value={props.link} readOnly={true} />
        </div>
        <div className="share_link_field_button">
            <PrimaryButton
                text={STRINGS.publishedModal.copy}
                left_icon={Assets.copy}
                type={ButtonTypes.OUTLINED}
                size={ButtonSize.MEDIUM}
                fontFamily={FontFamily.semiBold}
                iconSize={{ width: 16, height: 16 }}
                color={Colors.primaryTextColor}
                style={{ border: `1.5px solid ${Colors.primaryTextColor}` }}
                onClick={(e: React.MouseEvent) => {
                    e.stopPropagation();
                    props.onCopy();
                }}
            />
        </div>
    </div>
);

export default ShareLinkField;
